import EmailCampaignModule from "./EmailCampaignModule";

export default EmailCampaignModule;
